export function isDate(date: string): boolean {
  return (
    new Date(date).toString() !== 'Invalid Date' &&
    !isNaN(new Date(date) as any)
  );
}
